import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { auth } from '../lib/supabase';
import PasswordInput from '../components/PasswordInput';

const ResetPassword = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [validSession, setValidSession] = useState(false);

  useEffect(() => {
    // Verificar que el usuario tiene una sesión válida (token de reset)
    const checkSession = async () => {
      const { session, error } = await auth.getSession();

      if (error || !session) {
        toast.error('Link de restablecimiento inválido o expirado');
        navigate('/');
        return;
      }

      setValidSession(true);
    };

    checkSession();
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password.length < 6) {
      toast.error('La contraseña debe tener al menos 6 caracteres');
      return;
    }

    if (password !== confirmPassword) {
      toast.error('Las contraseñas no coinciden');
      return;
    }

    setLoading(true);
    try {
      const { error } = await auth.updatePassword(password);

      if (error) {
        throw error;
      }

      toast.success('¡Contraseña restablecida exitosamente!');
      // Redirigir al dashboard ya que el usuario está autenticado
      navigate('/dashboard');
    } catch (error) {
      console.error('Error resetting password:', error);
      toast.error(error.message || 'Error al restablecer contraseña');
    } finally {
      setLoading(false);
    }
  };

  if (!validSession) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-primary text-2xl font-heading">Verificando...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="glass p-8 rounded-card max-w-md w-full"
      >
        <h1 className="text-3xl font-heading font-bold text-text-primary mb-2 text-center">
          Restablecer Contraseña
        </h1>
        <p className="text-text-secondary text-center mb-6">
          Ingresa tu nueva contraseña
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-text-secondary mb-2">
              Nueva Contraseña
            </label>
            <PasswordInput
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Mínimo 6 caracteres"
              name="password"
              required
              testId="new-password-input"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-text-secondary mb-2">
              Confirmar Contraseña
            </label>
            <PasswordInput
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Repite la contraseña"
              name="confirmPassword"
              required
              testId="confirm-password-input"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full btn-neon py-3 rounded-button font-heading font-bold disabled:opacity-50"
            data-testid="submit-reset-btn"
          >
            {loading ? 'Restableciendo...' : 'Restablecer Contraseña'}
          </button>
        </form>
      </motion.div>
    </div>
  );
};

export default ResetPassword;
